import { Breadcrumb } from '@components/common/breadcrumb';
import { DestinationLinkBuilder, Name } from '@model/iceberg/geography';
import { withTheme } from '@emotion/react';
import React from 'react';
import { useI18NextContext } from '@components/hooks';
import { Item } from '@components/breadcrumbs/item';
import { TripTypes } from '@model/contentful';

export interface RegionsBreadcrumbProps {
  destination: Name;
}

export const RegionsBreadcrumbComponent = ({ destination }: RegionsBreadcrumbProps) => {
  const builder: DestinationLinkBuilder = new DestinationLinkBuilder();
  const t: any = useI18NextContext();
  const items: Array<Item> = [
    { ...builder.getDestinationLink(destination.path, TripTypes.HOLIDAYS), display: destination.display },
    { as: '', href: '', display: t('common__label--regions-in', { destination: destination.display }) }
  ];
  return <Breadcrumb items={items} />;
};

export const RegionsBreadcrumb = withTheme(RegionsBreadcrumbComponent);
